<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="6">
                <!-- Restaurant -->
                <v-card tile class="mb-4">
                    <v-card-subtitle>Restaurant</v-card-subtitle>
                    <v-divider />
                    <v-list-item>
                        <v-list-item-content v-if="order.orderable.restaurant">
                            <v-list-item-title
                                v-text="order.orderable.restaurant.name"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                                v-text="order.orderable.restaurant.phone"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle
                                v-if="order.orderable.restaurant.location"
                                v-text="
                                    order.orderable.restaurant.location.name
                                "
                            ></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <!-- End Restaurant -->
                <!-- Customer -->
                <v-card tile class="mb-4">
                    <v-card-subtitle>Customer</v-card-subtitle>
                    <v-divider />
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="order.customer_name"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                                v-text="order.customer_phone"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle
                                v-if="order.orderable.destination"
                                v-text="order.orderable.destination.name"
                            ></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <!-- End Customer -->
                <!-- Customer notes -->
                <v-card tile class="mb-4">
                    <v-card-subtitle>Customer's notes</v-card-subtitle>
                    <v-divider />
                    <v-card-text>{{
                        order.orderable.customer_notes
                    }}</v-card-text>
                </v-card>
                <!-- End Customer notes -->
                <!-- Operator notes -->
                <v-card tile class="mb-4">
                    <v-card-subtitle>Operator's notes</v-card-subtitle>
                    <v-divider />
                    <v-card-text>{{ order.operator_notes }}</v-card-text>
                </v-card>
                <!-- End Operator notes -->
                <!-- Payment -->
                <v-card tile class="mb-4 pb-1">
                    <v-card-subtitle>Details</v-card-subtitle>
                    <v-divider />
                    <v-simple-table dense class="ma-4">
                        <tbody>
                            <tr>
                                <th class="text--secondary">Payment type:</th>
                                <td>
                                    <v-chip small label>{{
                                        order.payment_type
                                    }}</v-chip>
                                </td>
                            </tr>
                            <tr>
                                <th class="text--secondary">Amount:</th>
                                <td>
                                    {{
                                        order.orderable.amount &&
                                            order.orderable.amount | currency
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th class="text--secondary">
                                    Service charge:
                                </th>
                                <td>
                                    {{
                                        order.service_charge &&
                                            order.service_charge | currency
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th class="text--secondary">
                                    Preparation time:
                                </th>
                                <td>
                                    {{
                                        order.orderable.prep_minutes &&
                                            `${order.orderable.prep_minutes} minutes`
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
                <!-- End Payment -->
                <!-- Courier -->
                <v-card tile class="mb-4">
                    <v-card-subtitle>Courier</v-card-subtitle>
                    <v-divider />
                    <v-list-item>
                        <v-list-item-content v-if="order.courierinfo">
                            <v-list-item-title
                                v-text="order.courierinfo.user.name"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                                v-text="order.courierinfo.user.phone"
                            ></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-else>
                            <v-list-item-subtitle
                                >(Not assigned)</v-list-item-subtitle
                            >
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            tile
                            color="primary"
                            class="mx-2"
                            v-on:click="showCourierSelectDialog = true"
                            >Assign</v-btn
                        >
                    </v-card-actions>
                </v-card>
                <!-- End Courier -->
                <!-- History -->
                <v-card tile class="mb-4">
                    <v-card-subtitle>History</v-card-subtitle>
                    <v-divider />
                    <order-status-stepper v-bind:order="order" />
                </v-card>
                <!-- End History -->
            </v-col>
            <v-col cols="12" md="6">
                <!-- Note: Use vue-zoomer to view photo -->
                <!-- Photo -->
                <v-card tile>
                    <v-card-subtitle>Photo</v-card-subtitle>
                    <v-divider />
                    <template v-if="order.orderable.photo">
                        <v-img v-bind:src="order.orderable.photo.url"></v-img>
                    </template>
                    <v-card-subtitle v-else>(No photo)</v-card-subtitle>
                </v-card>
                <!-- End Photo -->
            </v-col>
        </v-row>
        <courier-select-dialog
            v-bind:selectedItem="order.courierinfo"
            v-model="showCourierSelectDialog"
            v-on:selected="onCourierSelected"
        />
    </v-container>
</template>

<script>
export default {
    components: {
        'order-status-stepper': () =>
            import('@/components/OrderStatusStepper.vue'),
        'courier-select-dialog': () =>
            import('@/components/CourierSelectDialog.vue')
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showCourierSelectDialog: false
        };
    },
    methods: {
        onCourierSelected(courierinfo) {
            this.$emit('courier-selected', courierinfo);
        }
    }
};
</script>
